module.exports = __webpack_public_path__ + "img/twoOrange.b250b089.jpg";